var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/explicit-module-boundary-types */


import PropTypes from "prop-types";
import { css } from "styled-components";
import { map } from "../../breakpoint"; // Flex Direction:

export var validFlexDirectionValues = ["row", "column", "row-reverse", "column-reverse"];
export var flexDirection = function flexDirection(props) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
    var flexDirection = _ref.flexDirection;
    return map(flexDirection, function (val) {
      return val && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          flex-direction: ", ";\n        "])), val);
    });
  });
};
export var flexDirectionPropType = PropTypes.oneOf(validFlexDirectionValues);
export var flexDirectionPropTypeMap = PropTypes.oneOfType([flexDirectionPropType, PropTypes.shape({
  xs: flexDirectionPropType,
  sm: flexDirectionPropType,
  md: flexDirectionPropType,
  lg: flexDirectionPropType,
  xl: flexDirectionPropType,
  xxl: flexDirectionPropType,
  xxxl: flexDirectionPropType
})]); // Flex Wrap:

export var validFlexWrapValues = ["wrap", "nowrap"];
export var flexWrap = function flexWrap(props) {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref2) {
    var flexWrap = _ref2.flexWrap;
    return map(flexWrap, function (val) {
      return val && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          flex-wrap: ", ";\n        "])), val);
    });
  });
};
export var flexWrapPropType = PropTypes.oneOf(validFlexWrapValues);
export var flexWrapPropTypeMap = PropTypes.oneOfType([flexWrapPropType, PropTypes.shape({
  xs: flexWrapPropType,
  sm: flexWrapPropType,
  md: flexWrapPropType,
  lg: flexWrapPropType,
  xl: flexWrapPropType,
  xxl: flexWrapPropType,
  xxxl: flexWrapPropType
})]); // Flex Grow and Shrink

export var flexGrow = function flexGrow(props) {
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref3) {
    var flexGrow = _ref3.flexGrow;
    return map(flexGrow, function (val) {
      return val !== undefined && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          flex-grow: ", ";\n        "])), val);
    });
  });
};
export var flexShrink = function flexShrink(props) {
  return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref4) {
    var flexShrink = _ref4.flexShrink;
    return map(flexShrink, function (val) {
      return val !== undefined && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          flex-shrink: ", ";\n        "])), val);
    });
  });
};
export var flexGrowShrinkPropType = PropTypes.number;
export var flexGrowPropTypeMap = PropTypes.oneOfType([flexGrowShrinkPropType, PropTypes.shape({
  xs: flexGrowShrinkPropType,
  sm: flexGrowShrinkPropType,
  md: flexGrowShrinkPropType,
  lg: flexGrowShrinkPropType,
  xl: flexGrowShrinkPropType,
  xxl: flexGrowShrinkPropType,
  xxxl: flexGrowShrinkPropType
})]);
export var flexShrinkPropTypeMap = PropTypes.oneOfType([flexGrowShrinkPropType, PropTypes.shape({
  xs: flexGrowShrinkPropType,
  sm: flexGrowShrinkPropType,
  md: flexGrowShrinkPropType,
  lg: flexGrowShrinkPropType,
  xl: flexGrowShrinkPropType,
  xxl: flexGrowShrinkPropType,
  xxxl: flexGrowShrinkPropType
})]); // Align Items:

export var validAlignItemsValues = ["center", "flex-start", "flex-end"];
export var alignItems = function alignItems(props) {
  return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref5) {
    var alignItems = _ref5.alignItems;
    return map(alignItems, function (val) {
      return val && css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n          align-items: ", ";\n        "])), val);
    });
  });
};
export var alignItemsPropType = PropTypes.oneOf(validAlignItemsValues);
export var alignItemsPropTypeMap = PropTypes.oneOfType([alignItemsPropType, PropTypes.shape({
  xs: alignItemsPropType,
  sm: alignItemsPropType,
  md: alignItemsPropType,
  lg: alignItemsPropType,
  xl: alignItemsPropType,
  xxl: alignItemsPropType,
  xxxl: alignItemsPropType
})]); // Justify Content:

export var validJustifyContentValues = ["center", "flex-start", "flex-end", "space-between", "space-around", "space-evenly"];
export var justifyContent = function justifyContent(props) {
  return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref6) {
    var justifyContent = _ref6.justifyContent;
    return map(justifyContent, function (val) {
      return val && css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n          justify-content: ", ";\n        "])), val);
    });
  });
};
export var justifyContentPropType = PropTypes.oneOf(validJustifyContentValues);
export var justifyContentPropTypeMap = PropTypes.oneOfType([justifyContentPropType, PropTypes.shape({
  xs: justifyContentPropType,
  sm: justifyContentPropType,
  md: justifyContentPropType,
  lg: justifyContentPropType,
  xl: justifyContentPropType,
  xxl: justifyContentPropType,
  xxxl: justifyContentPropType
})]);